import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const chatbotApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('chatbotapi') || req.url.includes('chatbotsupervision') || req.url.includes("localhost")) {
    const cloned = req.clone({
      setHeaders: {
        accept: 'application/json',
        'api-key': environment.API_KEY_CHATBOT,
      },
    });
    return next(cloned);
  }

  return next(req);
};